﻿/*---[ ESLint ]---*/
/*
    global precommsggroup
*/

window.precommsggroup = function () {

    var LABEL_YES = "";
    var LABEL_NO = "";
    var LABEL_DELETE = "";

    function removeMessageGroup(preComMsgGroupId) {

        $.ajax({
            type: "POST",
            data:
            {
                preComMsgGroupId: preComMsgGroupId,
            },
            url: appsettings.getUrl("PreComMsgGroup/Delete"),
            success: function (responseData) {
                $("#PreComMsgGroupGrid").data("kendoGrid").dataSource.read();
                $("#DivMsgGrpUsers").html('');
            }
        });

    }


    return {

        initialize: function (labelYes, labelNo, labelDelete) {

            LABEL_YES = labelYes;
            LABEL_NO = labelNo;
            LABEL_DELETE = labelDelete;

            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                precommsggroup.addItem(e);
            });
        },

        /* Why is this ? Edit and adding are actions where the user needs to be redirected to. 
         * See group configuration. Set viewmode, Set navigation url to form / page for add or edit action. breadcrumb ....
         * use the same format for consistency */
        addItem: function (e) {
            $("#DivMsgGrpUsers").load(appsettings.getUrl("PreComMsgGroup/Add"));
        },

        showItem: function (e) {
            var selectedItem = this.dataItem($(e.currentTarget).closest("tr"));
            $("#DivMsgGrpUsers").load(appsettings.getUrl("PreComMsgGroup/Show?preComMsgGroupId=" + selectedItem.PreComMsgGroupID));
        },

        editItem: function (e) {
            var selectedItem = this.dataItem($(e.currentTarget).closest("tr"));
            $("#DivMsgGrpUsers").load(appsettings.getUrl("PreComMsgGroup/Edit?preComMsgGroupId=" + selectedItem.PreComMsgGroupID));
        },

        deleteItem: function (e) {

            var event = e;
            var data = this;

            function callbackYes(event, data) {
                // Prevent default behaviour 
                event.preventDefault();

                var dataItem = data.dataItem($(event.currentTarget).closest("tr"));

                // Post Data
                removeMessageGroup(dataItem.PreComMsgGroupID)
            }

            function callingCallback() {
                callbackYes(event, data);
            }

            dialog.createDialog(callingCallback, function () { });
        },

        onCancelButtonClicked: function (e) {
            $("#DivMsgGrpUsers").html('');
        },

        onSaveButtonClicked: function (e, preComMessageGroupId) {
            var label = $("#Label").data("kendoTextBox").value();
            var list = JSON.stringify($("#PreComMsg_CplSelected").data("kendoListBox").dataItems());

            $.ajax({
                type: "POST",
                data:
                {
                    preComMsgGroupId: preComMessageGroupId,
                    label: label,
                    assigned: list
                },
                url: appsettings.getUrl("PreComMsgGroup/Submit"),
                success: function (responseData) {

                    var grid = $("#PreComMsgGroupGrid").data("kendoGrid");
                    if (grid != null && grid != undefined) {
                        grid.dataSource.read();
                    }
                                        
                    $("#DivMsgGrpUsers").load(appsettings.getUrl("PreComMsgGroup/Edit?preComMsgGroupId=" + preComMessageGroupId), null, function () {
                        if (responseData != null && responseData != undefined) {
                            form.showServerResponse("LRShowResponse", responseData);
                        }
                    });
                }
            });
        }

    }

}();